import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/Authentication/Login';
import Register from '../pages/Authentication/Register';
import ForgotPassword from '../pages/Authentication/ForgotPassword';
import ResetPassword from '../pages/Authentication/ResetPassword';
import VerifyOtp from '../pages/Authentication/VerifyOtp';
import { ROLES } from '../config/constants';
import PrivateRoute from '../components/routes/PrivateRoute';
import Dashboard from '../pages/Dashboard';
import { routes } from './../config/utility';
import { UserContext } from '../context/UserContext';
import Reviews from '../pages/Reviews';
import Order from '../pages/Orders';
import SingleOrder from '../pages/SingleOrder';
import PromoCode from '../pages/Setting/PromoCode';
import Users from '../pages/Users';
import SingleUser from '../pages/SingleUser';
import Walker from '../pages/Walker';
import PetType from '../pages/Setting/PetType';
import PetAllergy from '../pages/Setting/PetAllergy';
import PetBreed from '../pages/Setting/PetBreed';
import Membership from '../pages/Setting/Membership';
import Role from '../pages/Setting/Role';
import AccessDeniedPage from '../pages/Error/403';
import NotFoundPage from '../pages/Error/404';
import WalkTool from '../pages/Setting/Tool';
import Pet from '../pages/Pet';
import Walk from '../pages/Walk';
import Delivery from '../pages/Delivery';
import UserProfile from '../pages/Profile';
import Partner from '../pages/Setting/Partner';
import PaymentSuccess from '../pages/PaymentSuccess';
import PaymentFailure from '../pages/PaymentFailed';
import TermsAndConditions from '../pages/TermsAndConditions';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import EULA from '../pages/EULA';
import SingleWalk from '../pages/Admin/SingleWalk';
import SingleDelivery from '../pages/Admin/SingleDelivery';
import AccountDeletions from '../pages/Admin/AccountDeletions';
import Guide from '../pages/Guide';
import Setting from '../pages/Setting';
import { createBrowserHistory } from 'history';
import AccountDeletionRequest from '../pages/Authentication/AccountDeletionRequest';
import AccountDeletionConfirmation from '../pages/Authentication/AccountDeletionConfirmation';
import AccountDeletionStatus from '../pages/Authentication/AccountDeletionStatus';


const history = createBrowserHistory();


const AppRoutes = () => {
  const { user } = useContext(UserContext);

  return (
    <Router history={history}>
      <Routes>
        <Route path={routes.terms} element={<TermsAndConditions />} />
        <Route path={routes.privacy_policy} element={<PrivacyPolicy />} />
        <Route path={routes.eula} element={<EULA />} />

        {/* <Route path={routes.terms} element={<PrivateRoute allowedRoles={[ROLES.ADMIN, ROLES.USER]}><TermsAndConditions /></PrivateRoute>} /> */}


        {/* Public Routes */}
        <Route path={routes.login} element={!user?.isAuthenticated ? <Login /> : <Navigate to={routes.dashboard} />} />
        <Route path={routes.registration} element={!user?.isAuthenticated ? <Register /> : <Navigate to={routes.dashboard} />} />
        <Route path={routes.forgot_password} element={!user?.isAuthenticated ? <ForgotPassword /> : <Navigate to={routes.dashboard} />} />
        <Route path={routes.reset_password} element={!user?.isAuthenticated ? <ResetPassword /> : <Navigate to={routes.dashboard} />} />
        <Route path={routes.verify} element={!user?.email_verified_at ? <VerifyOtp /> : <Navigate to={routes.dashboard} />} />
        <Route path={routes.account_deletion} element={<AccountDeletionRequest />} />
        <Route path={routes.account_deletion_verify} element={<AccountDeletionConfirmation />} />
        {/* <Route path={routes.account_deletion_status} element={<AccountDeletionStatus />} /> */}
        <Route path={routes.payment_success} element={<PaymentSuccess />} />
        <Route path={routes.payment_failed} element={<PaymentFailure />} />

        {/* Admin and User can access these routes */}
        <Route path={routes.guide} element={<PrivateRoute allowedRoles={[ROLES.ADMIN, ROLES.USER]}><Guide /></PrivateRoute>} />
        <Route path={routes.dashboard} element={<PrivateRoute allowedRoles={[ROLES.ADMIN, ROLES.USER]}><Dashboard /></PrivateRoute>} />
        <Route path={routes.review} element={<PrivateRoute allowedRoles={[ROLES.ADMIN, ROLES.USER]}><Reviews /></PrivateRoute>} />
        <Route path={routes.order} element={<PrivateRoute allowedRoles={[ROLES.ADMIN, ROLES.USER]}><Order /></PrivateRoute>} />
        <Route path={routes.order_detail} element={<PrivateRoute allowedRoles={[ROLES.ADMIN, ROLES.USER]}><SingleOrder /></PrivateRoute>} />
        <Route path={routes.walker} element={<PrivateRoute allowedRoles={[ROLES.ADMIN, ROLES.USER]}><Walker /></PrivateRoute>} />
        <Route path={routes.pet} element={<PrivateRoute allowedRoles={[ROLES.ADMIN, ROLES.USER]}><Pet /></PrivateRoute>} />
        <Route path={routes.walk} element={<PrivateRoute allowedRoles={[ROLES.ADMIN, ROLES.USER]}><Walk /></PrivateRoute>} />
        <Route path={routes.delivery} element={<PrivateRoute allowedRoles={[ROLES.ADMIN, ROLES.USER]}><Delivery /></PrivateRoute>} />
        <Route path={routes.profile} element={<PrivateRoute allowedRoles={[ROLES.ADMIN, ROLES.USER]}><UserProfile /></PrivateRoute>} />

        {/* Only Admins can access these routes*/}
        <Route path={routes.user} element={<PrivateRoute allowedRoles={[ROLES.ADMIN]}><Users /></PrivateRoute>} />
        <Route path={routes.user_detail} element={<PrivateRoute allowedRoles={[ROLES.ADMIN]}><SingleUser /></PrivateRoute>} />
        <Route path={routes.walk_single} element={<PrivateRoute allowedRoles={[ROLES.ADMIN]}><SingleWalk /></PrivateRoute>} />
        <Route path={routes.delivery_single} element={<PrivateRoute allowedRoles={[ROLES.ADMIN]}><SingleDelivery /></PrivateRoute>} />
        <Route path={routes.promo_code} element={<PrivateRoute isSetting={true} allowedRoles={[ROLES.ADMIN]}><PromoCode /></PrivateRoute>} />
        <Route path={routes.setting} element={<PrivateRoute isSetting={true} allowedRoles={[ROLES.ADMIN]}><Setting /></PrivateRoute>} />
        <Route path={routes.account_deletion_admin} element={<PrivateRoute allowedRoles={[ROLES.ADMIN]}><AccountDeletions /></PrivateRoute>} />
        <Route path={routes.pet_type} element={<PrivateRoute isSetting={true} allowedRoles={[ROLES.ADMIN]}><PetType /></PrivateRoute>} />
        <Route path={routes.pet_allergy} element={<PrivateRoute isSetting={true} allowedRoles={[ROLES.ADMIN]}><PetAllergy /></PrivateRoute>} />
        <Route path={routes.pet_breed} element={<PrivateRoute isSetting={true} allowedRoles={[ROLES.ADMIN]}><PetBreed /></PrivateRoute>} />
        <Route path={routes.membership} element={<PrivateRoute isSetting={true} allowedRoles={[ROLES.ADMIN]}><Membership /></PrivateRoute>} />
        <Route path={routes.walk_tool} element={<PrivateRoute isSetting={true} allowedRoles={[ROLES.ADMIN]}><WalkTool /></PrivateRoute>} />
        <Route path={routes.partner} element={<PrivateRoute isSetting={true} allowedRoles={[ROLES.ADMIN]}><Partner /></PrivateRoute>} />
        <Route path={routes.role} element={<PrivateRoute isSetting={true} allowedRoles={[]}><Role /></PrivateRoute>} />

        {/* Access Denied Page */}
        <Route path={routes['403']} element={<AccessDeniedPage />} />

        {/* Redirect other paths */}
        <Route path={routes.home} element={<Navigate to={routes.dashboard} />} />

        {/* Catch-all for undefined routes */}
        <Route path="*" element={<NotFoundPage />} />

      </Routes>
    </Router>
  );
};

export default AppRoutes;
